const steps = {
  LANDING: 'landing',
  INVOICE_DETAILS: 'invoice-details',
  PAYMENT: 'payment',
  REVIEW: 'review',
};

export default steps;
